<section class="how-to-buy pageHeight" id="how-to-buy">
  <img src="/assets/images/png/mob-line.png" class="img-fluid d-block mb-4" alt="line" *ngIf="isMobile">

    <h2 class="section-title mb-2" [innerHTML]="'how_to_buy.title' | translate "></h2>
    <h3 class="section-desc fw-bold">{{'how_to_buy.desc' | translate }}</h3>
    <div class="box-wrapper d-flex align-items-stretch gap-3">
      <div class="box" *ngFor="let item of items">
        <p class="box-title">{{item.title | translate }}</p>
        <p class="m-0" [innerHTML]="item.desc | translate "></p>
      </div>
    </div>
  <div class="drop-shadow mt-4 d-lg-inline-block d-none">
    <a routerLink="/{{ currentLanguage }}" fragment="roadmap" (click)="navigateToPage('roadmap')" class="btn btn-primary animation py-3 font-20 fw-semibold">{{ 'about.btn-check' | translate }}</a>
  </div>
  
  <div class="video-wrap">
    <video class="video" width="100%" #videoPlayer autoplay muted playsInline loop>
      <source src="/assets/images/videos/how-to-buy.mp4" type="video/mp4">
      Your browser does not support the video tag
    </video>
  </div>
  <img src="/assets/images/png/mob-line.png" class="img-fluid d-block mt-5 mb-4" alt="line" *ngIf="isMobile">

</section>